const modal = {
    overlay: 'fixed inset-0',
    title: {
        container: 'p-4 pt-6 md:px-6',
        text: 'text-2xl font-semibold text-left text-gray-800',
        subtext: 'text-sm text-left text-gray-600',
    },
    titleLeft: {
        container: 'p-4 pt-6',
        text: 'text-sm font-semibold text-left',
        bigText: 'text-2xl font-semibold text-gray-800',
        subtext: 'text-sm text-left text-gray-600',
    },
    footer: {
        container: 'px-4 pb-4 md:px-6',
        button_container: 'flex justify-between space-x-4',
        button: 'w-full',
    },
    footerFitCentered: {
        container: 'px-4 pb-4 md:px-6',
        button_container: 'flex justify-center space-x-4',
        button: 'w-fit',
    },
    closeIcon: {
        container: 'absolute top-0 right-0 z-10 pt-6 px-6 flex items-center justify-center',
        button: 'relative w-8 h-8 text-gray-400 transition-all rounded bg-white border border-gray-100 hover:bg-neutral-100 hover:text-gray-700',
    },
    padding: 'p-4 md:p-6',
    centered: {
        container: {
            outer: 'z-[900] fixed top-0 right-0 bottom-0 left-0 z-50 flex justify-stretch sm:justify-center items-stretch sm:items-center p-4',
            inner: 'relative z-10 w-full bg-[#F8F8F8] shadow rounded-lg xl:rounded-xl min-h-[200px] outline-none min-w-[100%] sm:min-w-0',
        },
        content: 'relative',
        transition: {
            'enter-active-class': 'duration-300 transition-overshoot',
            'enter-from-class': 'translate-y-[50px] sm:translate-y-0 sm:scale-90 opacity-0',
            'enter-to-class': 'translate-y-0 sm:scale-100 opacity-100',
            'leave-active-class': 'duration-200 ease-in',
            'leave-from-class': 'translate-y-0 sm:scale-100 opacity-100 blur-none',
            'leave-to-class': 'translate-y-[50px] sm:translate-y-0 sm:scale-90 opacity-0 blur-md',
        },
    },
    right_panel: {
        container: {
            outer: 'z-[900] fixed top-0 right-0 bottom-0 left-0 z-50 flex justify-end items-stretch p-4',
            inner: 'relative z-10 w-full bg-[#F8F8F8] shadow rounded-lg nice-scrollbar overflow-x-hidden md:rounded-xl h-[calc(100vh-32px)] outline-none sm:w-[540px] md:w-[600px] xl:w-[700px] 2xl:w-[800px] overflow-y-auto',
        },
        title: {
            container: 'p-4 sm:p-6 md:p-8',
            text: 'text-xl font-thin text-gray-800',
            bigText: 'text-2xl font-bold ',
        },
        content: 'flex flex-col h-full divide-y divide-gray-100',
        section: {
            container: 'p-4 sm:p-6 md:p-8',
            title: 'mb-2 text-base md:text-lg lg:mb-4',
        },
        transition: {
            'enter-active-class': 'duration-300 transition-ease-out-quad',
            'enter-from-class': 'translate-y-[50px] sm:translate-y-0 sm:translate-x-[150px] opacity-0',
            'enter-to-class': 'translate-y-0 sm:translate-x-0 opacity-100',
            'leave-active-class': 'duration-500 ease-in-out',
            'leave-from-class': 'translate-y-0 sm:translate-x-0 opacity-100 blur-none',
            'leave-to-class': 'translate-y-[50px] sm:translate-y-0 sm:translate-x-[150px] opacity-0 blur-sm',
        },
    },
};

modal.right_panel_full = JSON.parse(JSON.stringify(modal.right_panel));
modal.right_panel_full.container.outer = 'z-[900] fixed top-0 right-0 bottom-0 left-0 z-50 flex justify-end items-stretch p-0';
modal.right_panel_full.container.inner = 'relative z-10 w-[calc(100%-200px)] bg-white shadow rounded-l-lg nice-scrollbar overflow-x-hidden md:rounded-l-xl h-screen outline-none overflow-y-auto';

// Centered on desktop, fullscreen without padding on mobile.
modal.centered_mobile_full = JSON.parse(JSON.stringify(modal.centered));
modal.centered_mobile_full.container.outer = 'z-[900] fixed top-0 right-0 bottom-0 left-0 z-50 flex justify-stretch lg:justify-center items-stretch lg:items-center p-0 lg:p-4';
modal.centered_mobile_full.container.inner =
    'relative z-10 w-full h-full lg:h-auto bg-[#F8F8F8] shadow rounded-none lg:rounded-xl min-h-full lg:min-h-[200px] outline-none min-w-[100%] lg:min-w-0 overflow-y-auto';

// Profile review flow (V5): white card, 15px radius, centered on desktop, fullscreen without padding on mobile.
modal.centered_profile_review = JSON.parse(JSON.stringify(modal.centered));
modal.centered_profile_review.container.outer = modal.centered_mobile_full.container.outer;
modal.centered_profile_review.container.inner =
    'relative z-10 w-full h-full lg:h-auto bg-white shadow-[0_24px_48px_-16px_rgba(16,27,41,0.45)] rounded-none lg:rounded-card border-0 lg:border border-branding-border-grey min-h-full lg:min-h-[200px] outline-none min-w-[100%] lg:min-w-0 overflow-y-auto';

// Profile review favourite swap (V5): small white dialog, centered at every breakpoint, 16px radius on mobile and 15px on desktop.
modal.centered_profile_review_dialog = JSON.parse(JSON.stringify(modal.centered));
modal.centered_profile_review_dialog.container.outer = 'z-[900] fixed inset-0 z-50 flex justify-center items-center p-4';
modal.centered_profile_review_dialog.container.inner =
    'relative z-10 w-full bg-white shadow-[0_20px_50px_-12px_rgba(16,27,41,0.35)] rounded-2xl lg:rounded-card border border-zinc-200 outline-none min-w-[100%] sm:min-w-0';

// Right panel on desktop, fullscreen without padding on mobile.
modal.right_panel_mobile_full = JSON.parse(JSON.stringify(modal.right_panel));
modal.right_panel_mobile_full.container.outer = 'z-[900] fixed top-0 right-0 bottom-0 left-0 z-50 flex justify-end items-stretch p-0 lg:p-4';
modal.right_panel_mobile_full.container.inner =
    'relative z-10 w-full bg-white shadow rounded-none lg:rounded-lg nice-scrollbar overflow-x-hidden lg:rounded-xl h-screen lg:h-[calc(100vh-32px)] outline-none lg:w-[540px] xl:w-[700px] 2xl:w-[800px] overflow-y-auto';
modal.right_panel_mobile_full.title.container = 'p-4 sm:p-6';
modal.right_panel_mobile_full.section.container = 'p-4 sm:p-6';

// AI assistant overlay — full-width sheet layered over the host SaaS app.
// 50px top gap reveals the dim backdrop; the panel takes the rest of the
// viewport with rounded top corners. The close X is rendered inside the
// modal at fixed top-right, sitting in the 50px gap (outside the panel).
modal.ai_overlay = {
    container: {
        outer: 'fixed inset-0 flex flex-col items-stretch pt-[50px] p-0',
        inner: 'relative z-10 flex-1 w-full bg-white rounded-t-[18px] shadow-[0_-12px_48px_rgba(0,0,0,0.18),0_-2px_8px_rgba(0,0,0,0.06)] overflow-hidden outline-none',
    },
    content: 'h-full',
    transition: {
        'enter-active-class': 'duration-300 ease-out',
        'enter-from-class': 'translate-y-[40px] opacity-0',
        'enter-to-class': 'translate-y-0 opacity-100',
        'leave-active-class': 'duration-200 ease-in',
        'leave-from-class': 'translate-y-0 opacity-100',
        'leave-to-class': 'translate-y-[40px] opacity-0',
    },
};

modal.right_panel_pdf = JSON.parse(JSON.stringify(modal.right_panel));
modal.right_panel_pdf.container.inner =
    'relative z-10 w-full bg-white shadow rounded-lg nice-scrollbar overflow-x-hidden md:rounded-l-xl h-[calc(100vh-32px)] outline-none lg:w-[880px] overflow-y-auto';

// Photo gallery lightbox (Visibility, TDM-723) — centered two-pane panel (dark image + tags).
modal.gallery = {
    container: {
        outer: 'z-[900] fixed inset-0 flex items-center justify-center p-4 sm:p-8',
        inner: 'relative z-10 h-[640px] max-h-[90vh] w-[1040px] max-w-full overflow-hidden rounded-2xl bg-white shadow-popup outline-none',
    },
    content: 'relative h-full',
    transition: {
        'enter-active-class': 'duration-200 ease-out',
        'enter-from-class': 'scale-95 opacity-0',
        'enter-to-class': 'scale-100 opacity-100',
        'leave-active-class': 'duration-150 ease-in',
        'leave-from-class': 'scale-100 opacity-100',
        'leave-to-class': 'scale-95 opacity-0',
    },
};

export default modal;
